import { AxiosError } from 'axios';
import { GET_DOWNLOAD_ERROR_FILE_URL } from '../../constants/apiUrls';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_DOWNLOAD_ERROR_FILE_URL_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// =============================================================================
interface Input {
  enabled?: boolean;
  onSuccess?: (data: GetUrlResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  uuid: string;
}

interface GetUrlResponse {
  url: string;
}

export const useGetDownloadErrorFile = ({ uuid, enabled = false, onSuccess, onError }: Input) => {
  const getUploadTemplateDownloadUrl = async () => {
    const res = await axiosClient.get<GetUrlResponse>(GET_DOWNLOAD_ERROR_FILE_URL(uuid));
    return res.data;
  };
  return useCustomQuery([GET_DOWNLOAD_ERROR_FILE_URL_QUERY_KEY], getUploadTemplateDownloadUrl, {
    onSuccess,
    onError,
    enabled,
  });
};
